import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { QUERY_KEYS } from 'settings/config';
import { useApiReady } from './use-api-ready';

/** Get the general config object */
export function useListingAlert(enabled?: boolean) {
  return useQuery(
    [QUERY_KEYS.listingAlert],
    async () => {
      const { data } =
        await new ApiClient().ListingAlertApi.marketplaceListingAlertList();
      return data;
    },
    {
      enabled: enabled,
    }
  );
}
